import { Box, Paragraph } from 'theme-ui';

import { Link, Picture } from '@snippets';

import { useBreakpointValue } from '@hooks';

import { themed } from './Tile.theme';

export const Tile = themed(({ theme, item, settings, inputRef, ...props }) => {
  const { ratio, ratioDt, enableContained, roundedCorners } = settings;
  const { media, content } = item;
  const { image, video, alt, imageHover, videoHover } = media;
  const {
    superheading,
    superheadingMobile,
    heading,
    headingMobile,
    description,
    descriptionMobile,
    alignment,
    alignmentMobile,
    cta,
    style,
  } = content;
  const disableHoverMobile = useBreakpointValue([true, true, false]);

  const linkStyles = {
    ...(cta?.url ? theme.imageLink : theme.image),
    ...(roundedCorners && theme.roundedCorners),
  };

  return (
    <Box data-comp={Tile.displayName} {...props} className="h-full">
      <Link
        href={cta?.url}
        newTab={cta?.newTab}
        sx={linkStyles}
        className="h-full !flex flex-col"
      >
        <Picture
          alt={alt}
          images={[
            {
              src: image?.src,
              width: 768,
              ratio: parseFloat(ratio),
            },
            {
              src: image?.src,
              width: 700,
              ratio: parseFloat(ratioDt),
            },
          ]}
          hoverImages={[
            {
              src: imageHover?.src,
              width: 768,
              ratio: parseFloat(ratio),
            },
            {
              src: imageHover?.src,
              width: 700,
              ratio: parseFloat(ratioDt),
            },
          ]}
          video={video}
          videoHover={videoHover}
          videoRatio={parseFloat(ratio)}
          videoRatioDt={parseFloat(ratioDt)}
          disableHoverMobile={disableHoverMobile}
          width={image?.width}
          height={image?.height}
        />
        <Box
          sx={
            enableContained
              ? {
                  ...theme.overlayContained,
                  textAlign: alignment,
                }
              : {
                  ...theme.overlay,
                  textAlign: alignment,
                }
          }
          className="md:!flex flex-col flex-grow"
        >
          <Box className="flex flex-col flex-grow">
            {superheading && (
              <Paragraph sx={theme.superheading}>{superheading}</Paragraph>
            )}
            {heading && <Paragraph sx={theme.heading}>{heading}</Paragraph>}
            {description && (
              <Paragraph sx={theme.description}>{description}</Paragraph>
            )}
          </Box>
          {cta?.text && (
            <Paragraph
              variant={`buttons.${style || 'primary'}`}
              sx={theme.button}
              className="self-start"
            >
              {cta?.text}
            </Paragraph>
          )}
        </Box>
        <Box
          sx={
            enableContained
              ? {
                  ...theme.overlayContainedMobile,
                  textAlign: alignmentMobile,
                }
              : {
                  ...theme.overlayMobile,
                  textAlign: alignmentMobile,
                }
          }
          className="max-md:!flex flex-col flex-grow"
        >
          <Box className="flex flex-col flex-grow">
            {superheadingMobile && (
              <Paragraph sx={theme.superheading}>{superheadingMobile}</Paragraph>
            )}
            {headingMobile && (
              <Paragraph sx={theme.heading}>{headingMobile}</Paragraph>
            )}
            {descriptionMobile && (
              <Paragraph sx={theme.description}>{descriptionMobile}</Paragraph>
            )}
          </Box>
          {cta?.text && (
            <Paragraph
              variant={`buttons.${style || 'primary'}`}
              sx={theme.button}
              className="self-start"
            >
              {cta?.text}
            </Paragraph>
          )}
        </Box>
      </Link>
    </Box>
  );
});

Tile.displayName = 'Tile';